var _path, _path2, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2118 6.3343C5.06048 6.54447 5.00026 6.82669 5.00026 7V10C5.00026 10.8967 4.68273 11.6036 4.19084 12.1051C4.6212 12.5775 5.00026 13.2374 5.00026 14V17C5.00026 17.4741 5.1754 17.6739 5.33457 17.7885C5.54473 17.9398 5.82695 18 6.00026 18H7.00026V20H6.00026C5.50691 20 4.78913 19.8602 4.16596 19.4115C3.4918 18.9261 3.00026 18.1259 3.00026 17V14C3.00026 13.8831 2.90864 13.6286 2.61632 13.3545C2.48406 13.2305 2.3412 13.1335 2.21307 13.0712C2.15001 13.0406 2.09722 13.0216 2.05715 13.0109C2.01864 13.0006 2.00006 13 2.00006 13C2.00006 13 1.99992 13 2.00006 13L2.00026 11C2.21933 11 2.49102 10.9257 2.68462 10.7745C2.83931 10.6536 3.00026 10.4457 3.00026 10V7C3.00026 6.50664 3.14005 5.78887 3.58873 5.1657C4.07413 4.49153 4.87434 4 6.00026 4H7.00026V6H6.00026C5.52618 6 5.3264 6.17513 5.2118 6.3343Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7882 6.3343C18.9395 6.54447 18.9997 6.82669 18.9997 7V10C18.9997 10.8967 19.3173 11.6036 19.8092 12.1051C19.3788 12.5775 18.9997 13.2374 18.9997 14V17C18.9997 17.4741 18.8246 17.6739 18.6654 17.7885C18.4553 17.9398 18.173 18 17.9997 18H16.9997V20H17.9997C18.4931 20 19.2109 19.8602 19.834 19.4115C20.5082 18.9261 20.9997 18.1259 20.9997 17V14C20.9997 13.8831 21.0914 13.6286 21.3837 13.3545C21.5159 13.2305 21.6588 13.1335 21.7869 13.0712C21.85 13.0406 21.9028 13.0216 21.9428 13.0109C21.9814 13.0006 21.9999 13 21.9999 13C21.9999 13 22.0001 13 21.9999 13L21.9997 11C21.7807 11 21.509 10.9257 21.3154 10.7745C21.1607 10.6536 20.9997 10.4457 20.9997 10V7C20.9997 6.50664 20.86 5.78887 20.4113 5.1657C19.9259 4.49153 19.1257 4 17.9997 4H16.9997V6H17.9997C18.4738 6 18.6736 6.17513 18.7882 6.3343Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 1,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgState);
export default __webpack_public_path__ + "static/media/state.dc271e0b.svg";
export { ForwardRef as ReactComponent };